
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rockers",
      function () {
        return require("private-next-pages/rockers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rockers"])
      });
    }
  